import React, { Component } from "react";
import classes from "cssClasses";
import style from "./header.scss";
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';

class Header extends Component{
	render() {
		// console.log(this.props.auth);
		return (
			<div className={classes('header',style)}>
				<div className={classes('container')}>
					<div className={classes('row align-items-center')}>
						<Link to="/" className={classes('col-3 ml-auto mr-auto mr-md-0 ml-md-0 col-lg-1')}>
							<img src="https://courses.h-farm.com/app/themes/courses-h-farm/dist/images/logo.svg" alt="H-FARM"/>
						</Link>
						<div className={classes('col-12 col-main-menu col-md-10  mt-2 mt-md-0 col-lg-11 text-center text-md-right')}>
							Open Badges 
							{
								this.props.auth &&
								<span> | <span> </span>
									<Link to="/admin">Control panel</Link> 
								</span>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProp({auth}){
	return { auth }
}

export default connect(mapStateToProp)(Header);


// WEBPACK FOOTER //
// ./src/components/Frontend/Layout/Header/Header.js